module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-4 bg-gris-bleu rounded-lg shadow mb-4"
  }, [(_vm.ot) ? _c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("\n        Référence : "), _c('span', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.ot))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("\n        Intervention n° : "), _c('span', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.code))])]), _vm._v(" "), _c('h2', {
    staticClass: "text-md mt-1"
  }, [_vm._v("\n        Détenteur : "), _c('span', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.detenteur.raison_sociale) + " " + _vm._s(_vm.detenteur.ville))])]), _vm._v(" "), _c('p', {
    staticClass: "text-md mt-1"
  }, [_vm._v("\n        Installation : "), _c('span', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.installation.nom) + "\n            " + _vm._s((_vm.installation.marque) ? ' - ' + _vm.installation.marque : '') + "\n            " + _vm._s((_vm.installation.modele) ? ' - ' + _vm.installation.modele : ''))])]), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "flex items-center gap-3 mt-3"
  }, [(_vm.gotFluide) ? _c('div', {
    staticClass: "flex items-center gap-1 px-3 py-1 rounded-r-full bg-secondary text-white text-sm font-medium -ml-4"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-snow bg-white"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.installation.fluide.nom))])]) : _vm._e(), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "flex items-center gap-1"
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-weight bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md font-medium text-black"
  }, [_c('strong', [_vm._v(_vm._s(_vm.installation.charge))]), _vm._v(" kg")])]) : _vm._e(), _vm._v(" "), (_vm.gotFluide && _vm.isFibsdd) ? _c('div', {
    staticClass: "flex items-center gap-1"
  }, [_c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-co2 bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md font-medium text-black"
  }, [_vm._v(_vm._s(_vm.installation.tonnage))])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-185034d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/SmallRecap.vue
// module id = 1009
// module chunks = 0